import React from 'react';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { font, themeValue, withSiteTheme } from '../../../config/css';
import { color, mixins } from 'legacy-mise-ui/styles';

const CancelActionButtonTheme = {
  default: css`
    align-items: center;
    display: flex;
    font: ${font('14px', 'xsm', 'pnb')};
    height: 35px;
    justify-content: center;
    letter-spacing: ${themeValue('letterSpacing', 'md')};
    padding: 10px 16px;
    text-transform: uppercase;
    transition: background-color 0.2s linear;
    width: calc(50% - 8px);

    svg {
      transition: fill 0.2s linear;
    }

    ${breakpoint('tablet')`
      width: 163px;
    `}
  `,
};

const CancelActionButton = styled.button`
  ${withSiteTheme(CancelActionButtonTheme)};
  &:focus,
  &:active {
    ${mixins.focusIndicator(color.eclipse, '2px')}
  }
`;

const CancelAction = ({ url }) => {
  const onClickCancel = () => {
    if (window && window.history) {
      window.history.back();
    } else {
      window.location.href = url?.includes('/print')
        ? url?.replace('/print', '')
        : url;
    }
  };

  return (
    <CancelActionButton
      className="detail__actions detail__actions--cancel action-item"
      onClick={onClickCancel}
    >
      <span className="action-text">Cancel</span>
    </CancelActionButton>
  );
};

export default CancelAction;
